import TermsConditionsModule from "../modules/terms-conditions/TermsConditionsModule";

const TermsConditionsPage = () => {
  return <TermsConditionsModule />;
};

export default TermsConditionsPage;
